import { render, staticRenderFns } from "./price-card-loader.vue?vue&type=template&id=47051214&scoped=true&"
import script from "./price-card-loader.vue?vue&type=script&lang=js&"
export * from "./price-card-loader.vue?vue&type=script&lang=js&"
import style0 from "./price-card-loader.vue?vue&type=style&index=0&id=47051214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47051214",
  null
  
)

export default component.exports